const EQUALWEB_SHADOW_HOST_SELECTORS = ['#INDShadowRootHost', '#INDshadowRootWrap'];

const HIDE_EW_MENU_BTN =
  '#INDmenu-btn{position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;height:1px!important;opacity:0!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;padding:0!important;margin:0!important;}';

const EW_OFFSCREEN_STYLE_ID = 'equalweb-launch-offscreen';

function findEqualWebButton(): HTMLElement | null {
  const direct = document.getElementById('INDmenu-btn') as HTMLElement | null;
  if (direct) return direct;

  return EQUALWEB_SHADOW_HOST_SELECTORS.reduce<HTMLElement | null>((found, selector) => {
    if (found) return found;
    const host = document.querySelector(selector) as
      | (HTMLElement & { shadowRoot?: ShadowRoot })
      | null;
    return host?.shadowRoot?.querySelector<HTMLElement>('#INDmenu-btn') ?? null;
  }, null);
}

export function installEqualWebLaunchButtonOffscreenStyle(): void {
  if (typeof document === 'undefined') return;

  if (!document.getElementById(EW_OFFSCREEN_STYLE_ID)) {
    const inDoc = document.createElement('style');
    inDoc.id = EW_OFFSCREEN_STYLE_ID;
    inDoc.textContent = HIDE_EW_MENU_BTN;
    document.head.appendChild(inDoc);
  }

  EQUALWEB_SHADOW_HOST_SELECTORS.forEach(selector => {
    const host = document.querySelector(selector) as
      | (HTMLElement & { shadowRoot?: ShadowRoot })
      | null;
    const { shadowRoot } = host || {};
    if (shadowRoot && !shadowRoot.getElementById(EW_OFFSCREEN_STYLE_ID)) {
      const s = document.createElement('style');
      s.id = EW_OFFSCREEN_STYLE_ID;
      s.textContent = HIDE_EW_MENU_BTN;
      shadowRoot.appendChild(s);
    }
  });
}

export const showEqualWebDrawer = (): void => {
  installEqualWebLaunchButtonOffscreenStyle();
  const button = findEqualWebButton();
  if (button) button.click();
};
